import React from 'react';
import Content from "../../../components/layout/Content";
import { useDispatch } from "react-redux";
import { fetchGoods, fetchProductCategories } from "../../../action";
import BalanceList from "./BalanceList";
import { fetchFilials } from '../../../action/handbook';
import { fetchSettings } from '../../../action/app';


const Balance = () => {
    const dispatch = useDispatch();

    const onRefresh = async () => {
        dispatch(fetchProductCategories());
        dispatch(fetchFilials(null, true));
        dispatch(fetchGoods());
        dispatch(fetchSettings());
    }

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Остатки</h3>
                        <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    </div>
                    <div className="kt-subheader__toolbar">
                        <button onClick={onRefresh} className="btn btn-secondary btn-icon">
                            <i className="la la-refresh"></i>
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Content>
            {renderSubHeader()}
            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                    <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                        <BalanceList />
                    </div>
                </div>
            </div>
        </Content>
    );
}

export default Balance;